import { httpClient } from "@/httpClient";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import getPharmacyID from "@/utils/pharmacy_code";
// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/overview/sales_history/-components/component";
import {
  SalesHistory,
  SalesHistorySearchParams,
  UniqueUsersSalesSchema,
} from "@/routes/(pharma)/_layout/overview/-data/schema";
import { Loading } from "@/layouts/loading";
import { PharmacyInfo } from "@/routes/(pharma)/_layout/receipt/-data/model";
import { ListSalesResponse } from "@/gen/sales/list_sales_pb";
import { pharmacyClient } from "@/connect";
import { SaleStatus, SalesUsers } from "@/gen/sales/common_pb";


export const Route = createFileRoute("/(pharma)/_layout/overview/sales_history/")({
  component: Component,
  validateSearch: SalesHistorySearchParams,
});
